export const utf8ToBase64 = (str) => {
	return str && btoa(unescape(encodeURIComponent(str)))
}

export const base64ToUtf8 = (str) => {
	return str && decodeURIComponent(escape(atob(str)))
}
